import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentSipComponent } from './payment-sip.component';

const routes: Routes = [
  {
    path: '',
    component: PaymentSipComponent,
    data: {
      page_name: 'payment_sip',
      category: 'porfolio',
      sip: true,
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentSipRoutingModule { }
